import { CrudBuilderConfig } from '@core/components/crudbuilder/models/crud-builder-config';
import { FieldConfig } from '@core/components/crudbuilder/models/field-config';
import { DropdownFieldConfig, DropdownItem } from '@core/components/crudbuilder/models/dropdown-field-config';
import { BreadBuilderService } from '@core/services/bread-builder/bread-builder.service';
import { PopularAppStatesService } from '@core/services/popular-app-states/popular-app-states.service';

export class LifeInsuranceStepConfig extends CrudBuilderConfig {
  title       = 'Levensverzekering';
  singular    = 'Levensverzekering';
  plural      = 'Levensverzekeringen';
  getEndpoint = 'life-insurances';
  putEndpoint = 'life-insurances';
  multiEdit   = true;
  icon        = 'hand-holding-heart';

  path        = 'life-insurance';
  modelAlias  = PopularAppStatesService.TYPE_LIFE_INSURANCE;

  fields      = [
    new DropdownFieldConfig('type', 'Type', {
      contents: [
        new DropdownItem('Annuitair', 'ANNUITY'),
        new DropdownItem('Lineair', 'LINEAR'),
        new DropdownItem('Constant', 'CONSTANT'),
      ]
    }),
    new FieldConfig('annuity_percentage', FieldConfig.TYPE_NUMBER, 'Annuïteitenpercentage'),
    new FieldConfig('end_date', FieldConfig.TYPE_DATE, 'Einddatum'),
    new FieldConfig('insured_amount', FieldConfig.TYPE_MONEY, 'Verzekerd bedrag'),
    new FieldConfig('cost', FieldConfig.TYPE_MONEY, 'Premie per maand'),
    new FieldConfig('saving', FieldConfig.TYPE_MONEY, 'Besparing'),
    new FieldConfig('start_date', FieldConfig.TYPE_DATE, 'Start Datum'),
  ];

  runBeforeSaving(model, s: BreadBuilderService): any {
    // We just add the person id over here
    const acc = s.states.account.getCached();
    model.person_id = acc.id;
    return super.runBeforeSaving(model, s);
  }

  getReadTitle(model): string {
    if (model) {
      return model.type + ' ' + model.cost;
    }
  }

  hasCustomBackRoute = true;
  getCustomBackRoute() {
    return '/dashboard/fixed-charges';
  }

  runBeforeSavingOnAddView(model, s: PopularAppStatesService = null): any {
    const acc = s.account.getCached();
    model.person_id = acc.id;
    return super.runBeforeSavingOnEditView(model, s);
  }
}

export const LifeInsuranceStep = new LifeInsuranceStepConfig();
